import { h } from 'preact';
import { LoaderIcon } from '../Icons';
import './style.scss';

interface ISpinnerProps {
  className?: string;
  size?: number;
  color?: string;
  container?: boolean;
}

export default function Spinner({ className, size = 24, container = false, color }: ISpinnerProps) {
  return (
    <div className={className}>
      <div
        className={`spinner_ta ${container ? 'container_ta' : ''}`}
        style={{ width: size + 120, height: size + 120 }}
      >
        <LoaderIcon className={`spinner-icon_ta`} size={size} color={color} />
      </div>
    </div>
  );
}
